
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/cancellation-policy",
      function () {
        return require("private-next-pages/[locale]/help/cancellation-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/cancellation-policy"])
      });
    }
  